import React from 'react';
import './meetus4.css'
import Mainbt from '../components/common/mainbt';
import Meetusdiv from '../components/common/meetusdiv';
import m4 from '../assets/m4Icon.png'

const Meetus4 = () => {
    return ( <>
    <section>
            <div className="container">
                <div className="meets4">
                <Meetusdiv 
                muicon={m4}
                dicovertext='Navigate Fashion Week'
                mup='Interactive venue maps, designer booths, lounges, and real-time navigation'
                />
                <Mainbt mainbt="Get started" link="/login" />
                </div>
            
            </div>
    </section>
    </> );
}
 
export default Meetus4 ;